export default __webpack_public_path__ + "media/images/wood-swatches/dark-brown-wood-94f36c4cd2a963cd9f93a6f9eacb9161.jpg";